import { createAction, ActionType } from 'typesafe-actions'

export const errorClearAction = createAction('ERROR_CLEAR')<{}>()

export type ErrorActions = ActionType<typeof errorClearAction>
